import * as React from "react";
import { cn } from "./utils";

interface CheckboxFieldsetProps {
  label: string;
  required?: boolean;
  description?: string;
  error?: string;
  children: React.ReactNode;
  className?: string;
}

const CheckboxFieldset = ({
  label,
  required,
  description,
  error,
  children,
  className,
}: CheckboxFieldsetProps) => {
  return (
    <div className="space-y-1">
      <fieldset
        className={cn(
          "w-full rounded-[0.6rem] border px-3 pt-[2px] pb-[8px]",
          error ? "border-red-500" : "border-gray-300",
          className
        )}
      >
        <legend className="px-1">
          <span className="text-sm font-medium text-gray-700">
            {label}
            {required && <span className="text-red-500 ml-1">*</span>}
          </span>
        </legend>

        {description && (
          <p className="text-xs text-gray-500 mt-1 px-1">
            {description}
          </p>
        )}

        <div className="mt-2">{children}</div>
      </fieldset>

      {error && <p className="text-xs text-red-600">{error}</p>}
    </div>
  );
};

export { CheckboxFieldset };